export default __webpack_public_path__ + "static/media/showroom27.b7b7414e.jpg";